import React, { useState } from 'react';
import { PDFDocument, degrees } from 'pdf-lib';

export const RotateView: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [rotation, setRotation] = useState<number>(90);
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRotate = async () => {
    if (!file) {
      setError("Please select a PDF file.");
      return;
    }
    setIsProcessing(true);
    setError(null);
    try {
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await PDFDocument.load(arrayBuffer);
      const pages = pdf.getPages();
      
      for (const page of pages) {
        const currentRotation = page.getRotation().angle;
        page.setRotation(degrees(currentRotation + rotation));
      }
      
      const pdfBytes = await pdf.save();
      const blob = new Blob([pdfBytes as unknown as BlobPart], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'rotated.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, padding: '1rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <div>
          <h2 style={{ margin: 0 }}>Rotate PDF</h2>
          <p style={{ margin: '0.25rem 0 0', color: 'var(--color-text-secondary)' }}>Rotate all pages of a PDF entirely in your browser.</p>
        </div>
        <button onClick={() => { void handleRotate(); }} disabled={isProcessing} style={{ padding: '0.5rem 1rem', background: 'var(--color-accent)', color: 'var(--color-on-accent)', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 600 }}>
          {isProcessing ? 'Rotating...' : 'Rotate PDF'}
        </button>
      </div>
      {error && <div style={{ color: 'red', marginBottom: '1rem', padding: '0.5rem', background: '#ffebee', borderRadius: '4px' }}>{error}</div>}
      
      <div style={{ flex: 1, border: '2px dashed var(--color-border)', borderRadius: '8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
        <input 
          type="file" 
          accept="application/pdf" 
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              setFile(file);
            }
          }}
          style={{ marginBottom: '1rem' }}
        />
        {file && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
            <span>{file.name}</span>
            <select 
              value={rotation} 
              onChange={(e) => { setRotation(parseInt(e.target.value, 10)); }}
              style={{ padding: '0.5rem', borderRadius: '4px', border: '1px solid var(--color-border)' }}
            >
              <option value={90}>Rotate 90° Clockwise</option>
              <option value={180}>Rotate 180°</option>
              <option value={270}>Rotate 90° Counter-Clockwise</option>
            </select>
          </div>
        )}
      </div>
    </div>
  );
};
